import axios from "axios";
import { __constants } from "../../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

/* Babysitter Management */
export const getBabySitterAvailableForController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/available-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterAvailableForController >> ", err.message);
        return err.response
    }
}

export const addBabySitterAvailableForController = async (name,file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);   
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/available-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabySitterAvailableForController >> ", err.message);
        return err.response
    }
}

export const getBabySitterHappyWithController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/interested-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterHappyWithController >> ", err.message);
        return err.response
    }
}

export const addBabySitterHappyWithController = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/interested-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabySitterHappyWithController >> ", err.message);
        return err.response
    }
}

export const getBabySitterSpecialistInController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/speciality-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterSpecialistInController >> ", err.message);
        return err.response
    }
}

export const addBabySitterSpecialistInController = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/speciality-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabySitterSpecialistInController >> ", err.message);
        return err.response
    }
}

export const getBabaySitterHaveController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/service-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabaySitterHaveController >> ", err.message);
        return err.response
    }
}

export const addBabaySitterHaveController = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/service-for-babycare",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabaySitterHaveController >> ", err.message);
        return err.response
    }
}

export const getBabySitterExperienceController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/babysitter-experience",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterExperienceController >> ", err.message);
        return err.response
    }
}

export const addBabySitterChildrenExperienceController = async (name, file,greyImage, sno, id) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        formdata.append("sno", sno);

        formdata.append("id", id);

        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/childrange-experience",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabaySitterHaveController >> ", err.message);
        return err.response
    }
}

export const getBabySitterChildrenExperienceController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/childrange-experience",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterExperienceController >> ", err.message);
        return err.response
    }
}

export const addExperienceController = async (from, to, role, sno, id) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/user-experience",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: { from, to, role, sno, id }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabaySitterExperienceController >> ", err.message);
        return err.response
    }
}

export const deleteData = async (id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + `/v1/admin/preuser-detail/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in deleteData >> ", err.message);
        return err.response
    }
}

export const deleteDataExperience = async (id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + `/v1/admin/experience/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in deleteData >> ", err.message);
        return err.response
    }
}